import { t } from "i18next";
import React from "react";

const TerminiCondizioniPage = () => {
  const currentLink = window.location.href.split("/").slice(0, 3).join("/"); //es di funzionamento https://app-promoter.com/var/object => https://app-promoter.com

  return (
    <div style={{ width: "100%", height: "100dvh", overflow: "scroll" }}>
      <div className="flex flex-col m-auto justify-center p-2 2xl:w-7/12 xl:w-8/12 lg:w-9/12 md:w-10/12 w-full">
        {/* <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          /> */}
        <meta charSet="utf-8" />
        <p
          style={{
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "18pt",
          }}
        >
          <strong>
            <span style={{ fontFamily: "Montserrat" }}>
              Termini e condizioni del servizio
            </span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "18pt",
          }}
        >
          <strong>
            <span style={{ fontFamily: "Montserrat" }}>
              {t("environment")} by IBC S.r.l
            </span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Informazioni Generali
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Prima di accedere e utilizzare i servizi resi disponibili nella
            Applicazione online, attraverso il dominio
          </span>
          <a href={currentLink} style={{ textDecoration: "none" }}>
            <span className="Hyperlink" style={{ fontFamily: "Montserrat" }}>
              &nbsp;
            </span>
            <span className="Hyperlink" style={{ fontFamily: "Montserrat" }}>
              {currentLink}
            </span>
          </a>
          <span style={{ fontFamily: "Montserrat" }}>&nbsp;</span>
          <span style={{ fontFamily: "Montserrat" }}>
            e/o i suoi sottodomini, e/o nell’Applicazione mobile di{" "}
            {t("environment")} by IBC (da qui in avanti, collettivamente:
            “l’App”), legga attentamente questi Termini e Condizioni di Utilizzo
            (da qui in avanti, “Termini di Utilizzo”; “Termini”; “Condizioni”;
            “Termini e Condizioni”). Scaricando, installando o utilizzando
            l'App, o utilizzando i Servizi in qualsiasi modo, l'Utente conferma
            di aver letto e compreso il contenuto dei presenti Termini di
            Utilizzo del servizio {t("environment")} by IBC e accettato i
            seguenti termini e condizioni.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            I dati raccolti nel corso dell'utilizzo dell'App saranno trattati in
            conformità all'informativa privacy dell'App.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>Il Servizio</span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            La società IBC S.r.l., (da qui in avanti, "IBC"), con sede in Via
            Agostino Bertani 6, 20154 Milano (MI) - Italia, si dedica allo
            sviluppo dell'Applicazione {t("environment")} by IBC, un prodotto
            rivolto a sia a privati, sia ai professionisti incaricati degli
            adempimenti fiscali, finalizzato a facilitare l'acquisizione e la
            gestione della documentazione necessaria alla gestione della propria
            fiscalità attraverso un metodo di acquisizione e organizzazione
            della stessa basato su tecnologie digitali, inclusa l'IA.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Il servizio è offerto senza limitazioni geografiche e di residenza,
            ma è alla data odierna
          </span>
          <span style={{ fontFamily: "Montserrat" }}>&nbsp;</span>
          <strong>
            <span style={{ fontFamily: "Montserrat" }}>
              esclusivamente progettato per essere conforme e coerente con la
              fiscalità italiana.
            </span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            IL SERVIZIO {t("environment")} BY IBC, LE INFORMAZIONI PRESENTI
            NELLA WEB E NELL'APP NON COSTITUISCONO UN PARERE O UNA CONSULENZA
            TRIBUTARIA E FISCALE, NÉ UN SERVIZIO DI CONSULENZA LEGALE E NON
            PROVVEDONO IN ALCUN MODO ALLA PRESENTAZIONE DIRETTA DI DICHIARAZIONI
            FISCALI E/O DI INTERLOCUZIONE CON LA PUBBLICA AMMINISTRAZIONE, IVI
            INCLUSA L'AGENZIA DELLE ENTRATE. EVENTUALI SERVIZI IN DEROGA A
            QUANTO SOPRA (ES. INVIO DEL MOD.730) DEVONO INTENDERSI FORNITI IN
            VIA ECCEZIONALE, NON POTRANNO IN ALCUN CASO ESSERE INTERPRETATI
            ESTENSIVAMENTE E NON ESONERANO L'UTENTE DALLA VERIFICA DELLA
            CORRETTEZZA DEI DATI COINVOLTI.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            L'USO DEL SITO WEB E DELLA APP NON SOSTITUISCONO LA CONSULENZA E
            L'ASSISTENZA FISCALE DEI PROFESSIONISTI E GLI ENTI A CIO DEPUTATI,
            MA AGEVOLANO SOLTANTO IL CONTRIBUENTE e/o il PROFESSIONISTA NELLA
            CONOSCENZA DELLA NORMATIVA APPLICABILE E NELLA REPORTISTICA
            NECESSARIA ALL'ORGANIZZAZIONE ED ESECUZIONE DEGLI ADEMPIMENTI
            FISCALI.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            {t("environment")} by IBC è un metodo di analisi protetto da diritto
            d'autore ideato IBC S.r.l., che è titolare dei diritti esclusivi per
            lo sfruttamento economico dello stesso.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            La finalità del sistema è quella di facilitare e semplificare la
            relazione fra il contribuente ed il professionista fiscale, rendendo
            disponibile:
          </span>
        </p>
        <ul style={{ margin: "0pt", paddingLeft: "0pt" }}>
          <li
            style={{
              marginTop: "14pt",
              marginLeft: "27.6pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
            }}
          >
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                Un calendario e scadenziario dedicato alle incombenze fiscali;
              </span>
            </em>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
            }}
          >
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                Uno spazio di archiviazione e catalogazione della documentazione
                fiscale e delle relative pratiche;
              </span>
            </em>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
            }}
          >
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                Strumenti guidati di identificazione del proprio profilo
                fiscale;
              </span>
            </em>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
            }}
          >
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                Strumenti di riepilogo e sintesi;
              </span>
            </em>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
            }}
          >
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                L'acquisizione automatizzata in formato digitale dei relativi
                documenti;
              </span>
            </em>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
            }}
          >
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                L'invio automatico (sotto la responsabilità esclusiva del
                contribuente) del modello "730" per la dichiarazione dei
                redditi;
              </span>
            </em>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              marginBottom: "14pt",
              lineHeight: "normal",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
            }}
          >
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                Uno strumento di assistenza automatizzato basato
                sull'integrazione del sistema di IA Chat-GPT della società terza
                OpenAI.
              </span>
            </em>
          </li>
        </ul>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            La registrazione dell'Utente nell'Applicazione online e/o
            nell'Applicazione mobile di {t("environment")} by IBC ("Utente") e
            la fornitura del servizio da parte di IBC S.r.l. dipende
            dall'accettazione totale di questi termini e condizioni, di modo che
            qualsiasi Utente che non sia d'accordo o non voglia comportarsi
            secondo i suddetti, non potrà o dovrà cessare di utilizzare il
            servizio.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Le presenti disposizioni rimangono in vigore fra le parti durante
            tutta la durata del contratto che sarà determinata in funzione del
            piano concretamente stabilito.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            I termini di utilizzo per quanto concerne il software vengono
            applicati a tutti i modi di utilizzo delle Applicazioni, tanto in
            forma di codice, come in forma binaria, oppure in qualsiasi altra
            forma.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Definizione dei Termini
          </span>
        </p>
        <ul style={{ margin: "0pt", paddingLeft: "0pt" }}>
          <li
            style={{
              marginTop: "14pt",
              marginLeft: "27.6pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
            }}
          >
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                Per "App" si intendono le Applicazioni web ("webApp") e mobile,
                sviluppate da IBC S.r.l., la cui distribuzione e il cui utilizzo
                sono regolati dai presenti Termini di Utilizzo. Per sito web si
                intende il sito al dominio
              </span>
            </em>
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                &nbsp;
              </span>
            </em>
            <a href={currentLink} style={{ textDecoration: "none" }}>
              <em>
                <u>
                  <span
                    style={{
                      fontFamily: "Montserrat",
                      fontSize: "12pt",
                      color: "#0000ff",
                    }}
                  >
                    {currentLink}
                  </span>
                </u>
              </em>
            </a>
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                &nbsp;
              </span>
            </em>
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                e sottodomini.
              </span>
            </em>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
            }}
          >
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                Per "Abbonamento" si intende la sottoscrizione del servizio da
                parte di
              </span>
            </em>
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                &nbsp;
              </span>
            </em>
            <strong>
              <em>
                <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                  professionisti ed enti
                </span>
              </em>
            </strong>
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                &nbsp;
              </span>
            </em>
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                deputati agli adempimenti fiscali. Salvo diverso accordo, la
                sottoscrizione da parte di questi è sempre
              </span>
            </em>
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                &nbsp;
              </span>
            </em>
            <strong>
              <em>
                <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                  a pagamento
                </span>
              </em>
            </strong>
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                , mentre alla data di emissione del presente documento il
                servizio è
              </span>
            </em>
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                &nbsp;
              </span>
            </em>
            <strong>
              <em>
                <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                  gratuito per Utenti qualificati e qualificabili come
                  consumatori
                </span>
              </em>
            </strong>
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                &nbsp;
              </span>
            </em>
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                ai sensi del Codice del Consumo (D.Lgs 206/2005 ss.mm.ii).
              </span>
            </em>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
            }}
          >
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                Per "Distribuzione" si deve intendere il mezzo con il quale
                l'App è resa disponibile da IBC S.r.l. agli Utenti.
              </span>
            </em>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
            }}
          >
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                Per "Utente" si deve intendere chi, con qualunque mezzo, ha
                accesso all'area riservata, versione web e/o mobile del
                servizio. Possono essere "Utenti" sia persone fisiche per uso
                personale (ossia "consumatori"), sia professionisti ed enti
                deputati agli adempimenti fiscali.
              </span>
            </em>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              marginBottom: "14pt",
              lineHeight: "normal",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
            }}
          >
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                "Diritti di Proprietà Intellettuale" sono tutti quei diretti
                relativi a opere scientifiche in tutti i domini dell'attività
                umana, scoperte scientifiche, disegni, modelli industriali,
                marche industriali, commerciali e di servizio e alla protezione
                contro la concorrenza sleale, così come tutti gli altri diritti
                inerenti all'attività intellettuale nel dominio industriale e
                scientifico.
              </span>
            </em>
          </li>
        </ul>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>Licenza d'uso</span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            L'App e tutti i servizi ed accessori ad essa in qualunque modo
            connessi (incluso il sito web) sono di esclusiva proprietà di IBC
            S.r.l. e sono concesso solamente in diritto d'uso, gratuita o a
            pagamento secondo quanto selezionato e sempre personale all'Utente.
            All'Utente è concesso il diritto temporaneo, non esclusivo e non
            cedibile, per la durata dell'accordo, di utilizzare l'App in
            conformità con i presenti Termini e Condizioni. L'Utente ha il
            diritto di scaricare e installare una copia dell'App, o di accedere
            al servizio attraverso la webApp, usandolo entro i limiti delle
            funzionalità immediatamente e direttamente rese disponibili
            dall'App. L'Utente si impegna ad utilizzare il servizio
            esclusivamente nel rispetto ed entro i limiti previsti dal presente
            accordo ed in ossequio alle vigenti disposizioni di legge. In
            particolare, l'Utente non può: 1) creare opere derivate basate sul
            codice di sviluppo di questa Applicazione, violando i diritti
            industriali di IBC S.r.l. né effettuare attività di reverse
            engineering o copiare le idee originali sottostanti ai servizi di
            qualsiasi tipo e in qualsiasi modo; 2) utilizzare l'Applicazione per
            scopi diversi da quelli indicati nei presenti termini e condizioni;
            3) duplicare o copiare l'App, con la sola eccezione connessa al
            diritto di effettuare una copia di backup dei propri dati, tuttavia
            esclusa se tale azione è messa a disposizione da IBC S.r.l.; 4)
            vendere, assegnare, sub licenziare, distribuire, trasferire o
            rendere disponibile l'App o qualsiasi copia di essa in qualsiasi
            forma a terze parti; 5) modificare, adattare, alterare, tradurre, da
            compilare, disassemblare o decodificare il programma; 6) rimuovere o
            alterare le note e le indicazioni relative ai diritti vantati
            sull'App.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            L'Utente qualificabile e registrato come consumatore deve
            impegnarsi, infine, a non utilizzare le informazioni e i dati
            ottenuti tramite il servizio erogato per fornire prestazioni a
            favore di terzi, salvo diverso accordo in forma scritta e/o
            autorizzazione di IBC S.r.l. e riconoscendo in caso di violazione la
            facoltà ad IBC S.r.l. di applicargli e fatturare dalla data di
            registrazione i corrispettivi previsti per il servizio a pagamento.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Qualora l'Applicazione dovesse includere o essere fornita con
            elementi di software open source, si evidenzia che detti elementi
            sono soggetti alle condizioni di licenza, individuate nella relativa
            documentazione. I diritti sul software open source sono di
            titolarità dei rispettivi detentori, ivi indicati.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Salvo quanto espressamente previsto, il presente accordo non
            trasferisce alcun diritto di proprietà intellettuale o industriale
            sui contenuti veicolati attraverso l'App, ivi compresi eventuali
            marchi, segni distintivi o altre opere o contenuti soggetti a
            privativa, che restano, pertanto, di esclusiva titolarità dei
            rispettivi aventi diritto.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Servizi e materiali di terze parti
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            L'App può consentire l'accesso a servizi e siti web di terze parti
            (ossia qualunque funzionalità web-based, mobile o offline che opera
            con i servizi di IBC S.r.l. per {t("environment")} by IBC,
            complessivamente e individualmente indicati come "Servizi") sui
            quali IBC S.r.l. non esercita nessun controllo se non nella misura
            di verificarne l'integrazione solo formale con i propri servizi.
            L'utilizzo dell'App e dei Servizi può richiedere l'accesso a
            Internet o l'accesso a servizi di terze parti. Alcuni Servizi
            potranno essere regolati da termini diversi o aggiuntivi, che
            l'Utente dovrà accettare prima di utilizzare. L'inclusione di link
            ad altre Applicazioni o siti web è a scopo meramente informativo,
            essendo IBC S.r.l. interamente estranea ai rispettivi contenuti,
            servizi e/o prodotti offerti, non potendole essere imputata, in tal
            modo, nessuna responsabilità su tali contenuti.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            In particolare, il download della Applicazione su dispositivi mobili
            Android o iOS è sempre soggetto ai termini e condizioni di Alphabet
            Inc. ("Google play") e Apple Inc. ("Apple store").
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Inoltre, il servizio di chatbot è fornito direttamente da Open AI
            tramite l'applicazione Chat-GPT. Detta applicazione si basa su un
            sistema di intelligenza artificiale linguistico, che rielabora dati
            già presenti sul web, che, come tali, potrebbero non essere
            aggiornati e/o accurati e non può sostituire, ma solo affiancare, il
            parere e l'analisi critica di un professionista. Per maggiori
            informazioni e termini d'uso si invita a consultare la pagina
          </span>
          <span style={{ fontFamily: "Montserrat" }}>&nbsp;</span>
          <a
            href="https://openai.com/policies/terms-of-use"
            style={{ textDecoration: "none" }}
          >
            <u>
              <span style={{ fontFamily: "Montserrat", color: "#0000ff" }}>
                https://openai.com/policies/terms-of-use
              </span>
            </u>
          </a>
          <span style={{ fontFamily: "Montserrat" }}>.</span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>Limiti di utilizzo</span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            L'Utente accetta e riconosce espressamente che:
          </span>
        </p>
        <ul style={{ margin: "0pt", paddingLeft: "0pt" }}>
          <li
            style={{
              marginTop: "14pt",
              marginLeft: "27.6pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
            }}
          >
            <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
              L'App potrebbe non funzionare su tutti i dispositivi;
            </span>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
            }}
          >
            <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
              L'App e i Servizi includono contenuti, informazioni e materiali
              proprietari, protetti dalle leggi Applicabili in materia di
              proprietà intellettuale e da altre leggi, tra cui, a titolo
              esemplificativo e non esaustivo, il diritto d'autore, e che non
              utilizzerà tali contenuti, informazioni o materiali proprietari in
              alcun modo se non nei limiti stabiliti dai termini di utilizzo
              Applicabili.
            </span>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
            }}
          >
            <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
              Non utilizzerà l'App o i Servizi per ledere diritti di terzi o
              attuare condotte illecite.
            </span>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
            }}
          >
            <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
              Nel caso invii a mezzo di qualsiasi canale feedback e recensioni
              dei Servizi, questi saranno frutto della sua esperienza personale,
              veritieri e comunque rispettosi della reputazione di IBC S.r.l. e
            </span>
            <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
              &nbsp;
            </span>
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                {t("environment")} by IBC
              </span>
            </em>
            <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
              .
            </span>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              marginBottom: "14pt",
              lineHeight: "normal",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
            }}
          >
            <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
              Nel caso sia un professionista od ente di qualsiasi tipo, si
              registrerà al servizio a pagamento esclusivamente come tale e non
              come contribuente privato.
            </span>
          </li>
        </ul>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>Durata e Rinnovo</span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Accettando i presenti termini l'Utente accetta e concorda con
            l'iscrizione senza limiti di durata e sino a che IBC S.r.l. e suoi
            aventi causa lo renderanno disponibile al servizio{" "}
            {t("environment")} by IBC. Detta iscrizione non comporta alcun
            obbligo di utilizzo effettivo del servizio, né il pagamento di un
            corrispettivo in denaro, se non espressamente richiesto all'Utente e
            da esso accettato attivamente.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            IBC S.r.l. si riserva la facoltà, nel rispetto delle disposizioni di
            legge sulla privacy, di rendere in futuro disponibili o riservare a
            pagamento tutte o alcune delle funzionalità del servizio alla data
            di emissione del documento di luglio 2023 disponibili gratuitamente.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <em>
            <span style={{ fontFamily: "Montserrat" }}>
              LA SEGUENTE SEZIONE È APPLICABILE SOLO NEL CASO DI ATTIVAZIONE DI
              SERVIZI A PAGAMENTO per PROFESSIONISTI ED ENTI:
            </span>
          </em>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>Periodo di Prova</span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Se Applicabile e richiesto un pagamento, l'Utente, al termine del
            suddetto periodo di prova, non dovesse attivare l'abbonamento a
            pagamento, le funzionalità del servizio verranno immediatamente
            ridotte e per riattivare le piene funzionalità del servizio sarà
            necessario che l'Utente attivi un abbonamento a pagamento.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Attivazione dell'abbonamento, pagamenti e tariffe
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Con l'attivazione dell'Abbonamento l'Utente autorizza il pagamento
            automatico del valore concordato per mezzo delle informazioni di
            pagamento previamente rese disponibili dall'Utente.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            In caso di mancato pagamento entro il termine concordato, per
            qualsiasi motivo, IBC S.r.l. provvederà a sospendere la fornitura
            del servizio.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            IBC S.r.l. potrà modificare, di volta in volta, i prezzi
            dell'Abbonamento a Pagamento, incluse le tariffe del servizio,
            previa comunicazione anticipata all'Utente di qualsiasi modifica di
            prezzo e, se Applicabile, le modalità per l'accettazione della
            modifica. Il cambiamento del prezzo sarà efficace a partire dal
            periodo di abbonamento successivo alla data di modifica del prezzo.
            Nel rispetto della legge applicabile, l'Utente accetta il nuovo
            prezzo continuando ad utilizzare il Servizio dopo che la variazione
            di prezzo è resa efficace. Se l'Utente non desidera accettare la
            modifica del prezzo, ha diritto di rifiutare tale modifica
            annullando l'iscrizione all'abbonamento a pagamento prima che il
            cambio del prezzo diventi efficace.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Cancellazione dell'account
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            L'Utente ha sempre il diritto di cancellare l'account. In caso di
            cancellazione, IBC S.r.l. provvederà a rimuovere in un tempo
            ragionevole l'account cancellato e tutte le informazioni memorizzate
            relative all'Utente in conformità a quanto descritto
            nell'informativa privacy.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            La cancellazione dell'account non comporta il diritto alla rimozione
            di eventuali feedback, recensioni e messaggi diretti all'assistenza
            tecnica e commerciale, per i quali l'Utente concede ad IBC S.r.l. un
            diritto d'uso gratuito, temporalmente e geograficamente illimitato.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Termine e risoluzione
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            A seguito della cessazione del servizio per ragioni direttamente od
            anche indirettamente attribuibili all'Utente, IBC S.r.l. provvederà
            a sospendere automaticamente la fornitura del servizio e l'Utente
            rinuncia sin d'ora a richiedere la restituzione di ogni somma
            eventualmente già versata.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            IBC S.r.l. si riserva il diritto, a sua esclusiva discrezione, di
            modificare, sospendere o terminare l'Applicazione e il servizio
            erogato, in qualsiasi momento e senza preavviso, nonché nel caso in
            cui l'Utente violi i presenti Termini e Condizioni. In tale ultimo
            caso, il contratto dovrà considerarsi automaticamente risolto. Le
            informazioni sull'Utente che sono state memorizzate saranno
            prontamente rimosse in conformità con quanto riportato
            nell'Informativa Privacy.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Ugualmente l'Utente potrà, in qualsiasi momento e senza preavviso
            alcuno, cessare di utilizzare il servizio e/o rimuovere
            l'Applicazione da uno o più dispositivi sui quali è stata
            legittimamente installata.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Nel caso di servizi a pagamento la cessazione a discrezione di IBC
            S.r.l. comporterà l'obbligo di restituzione degli importi già
            versati dall'Utente per periodi non ancora fruiti.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>Registrazione</span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            IBC S.r.l. non si assume alcuna responsabilità per qualsiasi fatto o
            atto derivante dall'incapacità dell'Utente. IBC S.r.l. si impegna a
            rendere i propri servizi disponibili e utilizzabili senza
            inconvenienti, riservandosi, in ogni caso, il diritto di sospendere
            temporaneamente le sue operazioni per ragioni tecniche o per cause
            al di lá del suo controllo.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Informazioni obbligatorie per procedere con la registrazione:
          </span>
        </p>
        <ul style={{ margin: "0pt", paddingLeft: "0pt" }}>
          <li
            style={{
              marginTop: "14pt",
              marginLeft: "27.6pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
            }}
          >
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                Nome e cognome;
              </span>
            </em>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
            }}
          >
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                Codice fiscale proprio e di eventuali congiunti fiscali;
              </span>
            </em>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
            }}
          >
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                E-mail;
              </span>
            </em>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
            }}
          >
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                Luogo e/o Città di residenza;
              </span>
            </em>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
            }}
          >
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                Telefono e nome del commercialista di riferimento (opzionali);
              </span>
            </em>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              marginBottom: "14pt",
              lineHeight: "normal",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
            }}
          >
            <em>
              <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                P. IVA e sede legale(se applicabili).
              </span>
            </em>
          </li>
        </ul>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Al momento della registrazione e durante l'utilizzo del software e
            dei servizi, l'Utente dovrà fornire informazioni esatte, precise e
            veritiere. IBC S.r.l. non risponde, in ogni caso, della veridicità,
            esattezza e autenticità dei dati personali inseriti, e non si assume
            alcuna responsabilità della verifica di questi ultimi, che è
            essenziale per la corretta fruizione dei servizi da parte
            dell'Utente stesso.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Responsabilità di IBC S.r.l.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Accettando i presenti Termini e Condizioni, l'Utente si impegna ad
            adottare comportamenti che non infrangano l'ordine giudiziario
            vigente o che ledano, in qualsiasi modo, posizioni giuridicamente
            protette, impegnandosi a seguire minuziosamente la legislazione,
            anche europea, nell'ambito della protezione dei dati personali, come
            il Regolamento Generale sulla Protezione dei dati ("GDPR").
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            L'Utente è l'unico responsabile della propria condotta fiscale e del
            puntuale adempimento degli obblighi di dichiarazione e versamento,
            propri o di cui sia incaricato.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Inoltre, IBC S.r.l. potrà occasionalmente mettere a disposizione dei
            servizi potenzialmente migliorativi in test (c.d.
          </span>
          <span style={{ fontFamily: "Montserrat" }}>&nbsp;</span>
          <em>
            <span style={{ fontFamily: "Montserrat" }}>beta testing</span>
          </em>
          <span style={{ fontFamily: "Montserrat" }}>
            ): in tal caso l'Utente sarà libero di utilizzare o meno detti
            servizi, prendendo atto che in ragione di tale natura di test, IBC
            S.r.l. non presterà alcuna garanzia di funzionamento e/o accuratezza
            e/o effettivo miglioramento.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Cessione del contratto
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            L'Utente accetta sin da ora che IBC S.r.l. possa cedere i propri
            diritti ed obblighi derivanti dai presenti Termini e Condizioni
            (anche in caso di cessione di azienda o di ramo di azienda), valendo
            tale accettazione come preventivo consenso alla cessione, purché
            vengano ceduti agli stessi termini o a termini che non siano meno
            vantaggiosi per l'Utente. Tale cessione, con le relative modalità di
            esecuzione, dovrà essere previamente notificata all'Utente, a
            propria descrizione attraverso la pubblicazione sul sito web o App o
            la notifica personale all'Utente.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            È fatto divieto all'Utente di cedere ad altri il proprio account ed
            in generale qualsiasi diritto e/o obbligo derivante dai presenti
            Termini e Condizioni.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            In caso di violazione da parte dell'Utente del suddetto divieto di
            cessione, la cessione si intenderà come non avvenuta e quindi priva
            di effetti nei rapporti con IBC S.r.l., che avrà la facoltà di
            ritenere risolti i presenti Termini e Condizioni.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "13.5pt",
          }}
        >
          <strong>
            <span style={{ fontFamily: "Montserrat" }}>
              Proprietà Intellettuale
            </span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Le Applicazioni prodotte da IBC S.r.l. sono opere intellettuali
            protette dal Diritto di Proprietà Intellettuale, ovvero dalla
            legislazione Applicabile, ovvero dalla direttiva Europea 91/250/CEE
            e il D. Lgs. 518/1992. Ogni elemento che compone le Applicazioni
            (come design, testi, video, musiche, grafici, immagini,
            informazioni, Applicazioni, suoni, colori, logotipi, layout della
            pagina web, Applicazioni e ferramenta, ecc..) sono proprietà
            esclusiva di IBC S.r.l., l'unico soggetto giuridico abilitato ad
            utilizzare i diritti di proprietà intellettuale qui sopra riferiti.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            È espressamente proibita qualsiasi riproduzione e/o rappresentazione
            integrale o parziale, utilizzo, adattamento o modifica delle
            Applicazioni o di qualsiasi elemento che la compone, in qualsiasi
            forma o per altri fini commerciali.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            IBC S.r.l. potrà acquisire gratuitamente e costituirà sua propria
            Proprietà intellettuale qualunque segnalazione dell'Utente relativa
            alla funzionalità dei Servizi ed allo stesso modo ricavare
            informazioni utili al miglioramento degli stessi dall'iterazione
            dell'Utente con il proprio sito web ed App, nel rispetto delle norme
            a tutela della Privacy.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "13.5pt",
          }}
        >
          <strong>
            <span style={{ fontFamily: "Montserrat" }}>Riservatezza</span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            L'Utente si impegna a mantenere in assoluta e totale riservatezza
            qualsiasi dato personale o commerciale, anche nel caso non venga
            menzionato come riservato, facente parte dell'informazione resa ad
            egli disponibile, alla quale avrà accesso.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Per informazione protetta o confidenziale si intende qualsivoglia
            informazione che, indipendentemente dal formato utilizzato consista
            in informazione tecnica e non tecnica, di natura finanziaria,
            commerciale o tecnologica, in particolare: proprietà intellettuale e
            industriale, "know-how", conclusioni, modelli di commercio, modelli
            di lavoro, segreti commerciali, studi, formule, metodi, "bozze",
            disegni, fotografie, mostre di prototipi, modelli, dati finanziari,
            tecnologici e informazioni connessi, direttamente o indirettamente,
            con la distribuzione della versione pre-beta del framework del
            software, o qualsiasi altro elemento commerciale, giuridico e/o
            fiscale, o qualsiasi altra informazione relativa al software, che
            sia distribuita in qualsiasi forma.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "13.5pt",
          }}
        >
          <strong>
            <span style={{ fontFamily: "Montserrat" }}>Forza maggiore</span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Entrambe le Parti non saranno responsabili per l'inadempimento delle
            proprie obbligazioni qualora questo sia dovuto a eventi che siano
            estranei al controllo delle Parti stesse, includendo a mero titolo
            esemplificativo, pandemie, guerre, inondazioni, cataclismi e
            qualsiasi altra causa che la parte non abbia la possibilità di
            prevenire usando la normale diligenza.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Qualora la causa di forza maggiore dovesse perdurare per un termine
            superiore a sei (6) mesi, le Parti potranno concordare eventuali
            modifiche da apportare al rapporto contrattuale o la risoluzione del
            medesimo.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "13.5pt",
          }}
        >
          <strong>
            <span style={{ fontFamily: "Montserrat" }}>
              Esclusione di garanzie
            </span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            L'UTENTE COMPRENDE E ACCETTA CHE IL SERVIZIO {t("environment")} BY
            IBC È OFFERTO "COSÌ COME È" E "COME DISPONIBILE" (C.D. "AS IS"),
            SENZA ALCUNA GARANZIA O CONDIZIONE ESPLICITA O IMPLICITA DI ALCUN
            GENERE.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            IBC S.r.l. non garantisce che l'applicazione o il servizio erogato
            operino sempre senza errori o senza interruzioni. Salvo quanto
            espressamente e specificamente previsto nel presente accordo, e
            nella misura massima consentita dalla legge applicabile, IBC S.r.l.
            non presta alcuna garanzia (esplicita o implicita) in relazione
            all'applicazione o al servizio erogato, incluse, in via
            esemplificativa e non esaustiva, garanzie di qualità, di adeguatezza
            per uno scopo specifico, o qualsiasi altra garanzia implicita
            derivante dalla prassi o dagli usi commerciali. IBC S.r.l., sempre
            nella misura massima consentita dalla legge applicabile, non
            presterà alcuna garanzia relativamente alla compatibilità
            dell'applicazione con particolari piattaforme e relativamente agli
            effetti che potranno verificarsi sulla funzionalità di software,
            servizi o prodotti di terze parti, in ragione dell'installazione e/o
            adozione dell'App e del servizio erogato.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            L'intelligenza artificiale e l'apprendimento automatico sono campi
            di studio in rapida evoluzione. IBC S.r.l. lavora costantemente per
            migliorare i nostri Servizi per renderli più accurati, affidabili,
            sicuri e vantaggiosi. Data la natura probabilistica
            dell'apprendimento automatico, l'uso dei nostri Servizi può in
            alcune situazioni comportare un output errato che non riflette
            accuratamente persone, luoghi o fatti reali.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            La funzione di invio delle dichiarazioni dei redditi richiede sempre
            la supervisione attiva dell'Utente e del proprio esperto fiscale di
            fiducia.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            L'Utente è invitato a valutare l'accuratezza di qualsiasi output in
            modo appropriato per il suo caso d'uso, anche utilizzando la
            revisione umana dell'output ed avvalendosi di esperti in materia
            fiscale.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            L'Utente accetta espressamente che:
          </span>
        </p>
        <ul style={{ margin: "0pt", paddingLeft: "0pt" }}>
          <li
            style={{
              marginTop: "14pt",
              marginLeft: "27.6pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
            }}
          >
            <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
              l'utilizzo del servizio è effettuato per suo conto e a suo
              rischio, essendo di sua esclusiva responsabilità;
            </span>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
            }}
          >
            <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
              IBC S.r.l. non fornisce nessuna garanzia:
            </span>
            <ul
              style={{
                marginRight: "0pt",
                marginLeft: "0pt",
                paddingLeft: "0pt",
              }}
            >
              <li
                style={{
                  marginLeft: "29pt",
                  marginBottom: "0pt",
                  paddingLeft: "7pt",
                }}
              >
                <em>
                  <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                    in relazione alla corrispondenza del software con le
                    esigenze dell'Utente;
                  </span>
                </em>
              </li>
              <li
                style={{
                  marginLeft: "29pt",
                  marginBottom: "0pt",
                  paddingLeft: "7pt",
                }}
              >
                <em>
                  <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                    in relazione all'aggiornamento ed ai tempi di aggiornamento
                    del software rispetto alla normativa fiscale;
                  </span>
                </em>
              </li>
              <li
                style={{
                  marginLeft: "29pt",
                  marginBottom: "0pt",
                  paddingLeft: "7pt",
                }}
              >
                <em>
                  <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                    in relazione alla corrispondenza del software a casi dubbi
                    che necessitino di un'interpretazione attiva della normativa
                    fiscale;
                  </span>
                </em>
              </li>
              <li
                style={{
                  marginLeft: "29pt",
                  marginBottom: "0pt",
                  paddingLeft: "7pt",
                }}
              >
                <em>
                  <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                    in relazione all'effettivo riconoscimento da parte degli
                    Enti a ciò preposti di specifiche detrazioni, deduzioni e
                    sconti e/o agevolazioni fiscali in genere;
                  </span>
                </em>
              </li>
              <li
                style={{
                  marginLeft: "29pt",
                  marginBottom: "0pt",
                  paddingLeft: "7pt",
                }}
              >
                <em>
                  <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                    che l'Applicazione o il servizio erogato operino sempre
                    senza errori o senza interruzioni;
                  </span>
                </em>
              </li>
              <li
                style={{
                  marginLeft: "29pt",
                  marginBottom: "14pt",
                  paddingLeft: "7pt",
                }}
              >
                <em>
                  <span style={{ fontFamily: "Montserrat", fontSize: "12pt" }}>
                    in relazione all'affidabilità, attualità o performance del
                    software;
                  </span>
                </em>
              </li>
            </ul>
          </li>
        </ul>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "13.5pt",
          }}
        >
          <strong>
            <span style={{ fontFamily: "Montserrat" }}>
              Limitazione di responsabilità
            </span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            L'Utente comprende e concorda espressamente che IBC S.r.l. non potrà
            essere ritenuta responsabile di fronte all'Utente per qualsiasi
            danno diretto, indiretto, accidentale o speciale, derivato
            dall'utilizzo dell'App. Allo stesso modo IBC S.r.l. non potrà essere
            ritenuta responsabile delle inadempienze del Professionista
            nell'adempimento dei suoi obblighi imposti dalla legge, ovvero di
            quelli derivanti dal regolamento Generale sulla Protezione dei Dati.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            IBC S.r.l., nella gestione dell'Applicazione o del servizio offerto,
            non opera alcuna verifica, selezione in base alla rilevanza, o
            valutazione, e non assume alcuna responsabilità, in relazione al
            contenuto dei documenti eventualmente messi a disposizione dagli
            utenti. IBC S.r.l. non è responsabile per gli eventuali danni
            derivanti dall'utilizzo, o dal mancato utilizzo, dell'Applicazione o
            del servizio erogato, e dei dati attraverso di essi veicolati, a
            meno che tali danni siano derivati palesemente da dolo o colpa
            grave. IBC S.r.l. non sarà mai responsabile dei danni indiretti, di
            qualsiasi tipo e natura, ivi incluso il mancato riconoscimento di
            vantaggi fiscali di qualsiasi genere e/o l'irrogazione di sanzioni
            per l'errato o fraudolento adempimento di obblighi fiscali. Fermo
            restando l'impegno nel cercare di garantire la continuità
            dell'Applicazione o del servizio erogato, IBC S.r.l. non presta
            alcuna garanzia e, nei limiti previsti dalla normativa Applicabile,
            non sarà in alcun modo responsabile, per le ipotesi di ritardi,
            malfunzionamenti, interruzioni e/o sospensioni dell'accesso ai dati
            causati da: (A) errato utilizzo dell'Applicazione o del servizio
            erogato da parte dell'Utente; (B) malfunzionamenti di qualsiasi tipo
            del dispositivo utilizzato dall'Utente; (C) interruzioni totali o
            parziali, o in ogni caso inefficienze, dei servizi forniti dagli
            operatori di telecomunicazioni o da qualunque altro soggetto terzo
            addetto alla trasmissione dei dati; (D) operazioni di manutenzione
            prestate dall'ente al fine di salvaguardare l'efficienza e la
            sicurezza dell'Applicazione e del servizio erogato; (E) qualsiasi
            altra causa non imputabile a IBC S.r.l..
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            L'Applicazione e il servizio offerto sono dotati di efficaci misure
            di sicurezza e di procedure di autenticazione finalizzate a
            consentire l'accesso ai dati esclusivamente a favore dell'Utente
            legittimato ad accedervi. L'Utente è tenuto all'efficace e
            scrupolosa custodia delle credenziali di autenticazione necessarie
            per accedere al servizio, a non comunicare a soggetti terzi le
            predette credenziali, e a modificare e aggiornare le stesse
            periodicamente, assumendo ogni responsabilità al riguardo. L'Utente
            accetta, altresì, che qualora dovesse procedere a sua discrezione,
            anche attraverso funzionalità non previste dall'Applicazione, a
            esportare i dati al di fuori dell'Applicazione memorizzandoli sul
            suo dispositivo mobile, le misure di sicurezza implementate
            nell'Applicazione e nel servizio erogato non saranno più efficaci
            per proteggere i suoi dati, i quali potranno essere soggetti al
            rischio di accesso abusivo da parte di soggetti non autorizzati. In
            egual misura, all'eventuale atto di disinstallazione
            dell'Applicazione, sarà indispensabile provvedere alla cancellazione
            dei dati esportati al di fuori dell'Applicazione e/o memorizzati sul
            dispositivo. L'Utente assume ogni responsabilità in relazione
            all'efficace custodia del proprio dispositivo mobile, all'eventuale
            Applicazione di ulteriori strumenti (quali codici di accesso o
            sistemi biometrici) finalizzati a prevenire accessi non consentiti
            al dispositivo stesso, e accetta che IBC S.r.l. non sarà in alcun
            modo, e in nessun caso, responsabile di eventuali accessi abusivi ai
            propri dispositivi e comunque causati da imperizia nella gestione
            del dispositivo e delle proprie credenziali di autenticazione.
            Ugualmente IBC S.r.l. non sarà in nessun caso responsabile degli
            eventuali danni arrecati ai dati per la presenza, sul dispositivo
            dell'Utente, di codice maligno (virus informatici, trojan horses,
            worms, o altra tipologia di malware) e/o dall'interazione con
            software di terze parti.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Interpretazione esclusione di garanzie ed esclusione di
            responsabilità
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Se l'esclusione di garanzia e/o la limitazione di responsabilità di
            cui sopra non possono avere efficacia così come espresse, andrà
            Applicata la norma che più si avvicina ad una rinuncia assoluta ad
            ogni responsabilità civile in relazione all'App, a meno che una
            garanzia o un'assunzione di responsabilità non accompagni la licenza
            d'uso dell'App a fronte di un corrispettivo.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "13.5pt",
          }}
        >
          <strong>
            <span style={{ fontFamily: "Montserrat" }}>Errori nel sistema</span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Non è permesso l'utilizzo di nessun dispositivo, software, o altro
            ricorso che venga ad interferire nelle attività e nelle operazioni
            di IBC S.r.l. e della sua App. Qualsiasi intromissione, tentativo, o
            attività che violino, oppure contravvengano alle leggi sul diritto
            della proprietà intellettuale e/o alle proibizioni stipulate in
            questi Termini di Utilizzo, renderanno il responsabile passibile di
            azioni legali pertinenti, volte al risarcimento per gli eventuali
            danni causati.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            IBC S.r.l. non è responsabile per qualsivoglia perdita e/o danno
            alla strumentazione dell'Utente causata da errori nel sistema, nel
            server o in Internet.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Trattamento dei dati personali
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            I dati degli Utenti raccolti tramite l' App saranno trattati in
            conformità all'informativa privacy dell'App.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            I dati degli Utenti attraverso l'App sono trattati da IBC S.r.l. in
            qualità di Titolare Responsabile del trattamento, ai sensi di quanto
            stabilito dall'art. 28 del GDPR.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Accettando questi Termini e Condizioni l'Utente accetta anche
            l'Accordo sul trattamento dei dati personali con IBC S.r.l. Accordo
            sul Trattamento dei Dati Personali
          </span>
          <span style={{ fontFamily: "Montserrat" }}>&nbsp;</span>
          <a
            href="http://www.ibc.srl/privacy"
            style={{ textDecoration: "none" }}
          >
            <span className="Hyperlink" style={{ fontFamily: "Montserrat" }}>
              al seguente link.
            </span>
          </a>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            IBC S.r.l. dà atto di aver altresì sottoscritto in data … un accordo
            di contitolarità con … per la gestione e trattamento dei dati
            personali. Maggiori informazioni e dettagli possono essere richieste
            scrivendo a:
          </span>
          <span style={{ fontFamily: "Montserrat" }}>&nbsp;</span>
          <strong>
            <span style={{ fontFamily: "Montserrat" }}>assistenza@ibc.srl</span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "13.5pt",
          }}
        >
          <strong>
            <span style={{ fontFamily: "Montserrat" }}>
              RESPONSABILE DEL TRATTAMENTO
            </span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Nel caso in cui i dati personali siano raccolti attraverso l'App nel
            contesto del rapporto tra un Professionista (es.: Commercialista,
            impiegato di un Caf, ecc…) e il proprio Cliente, laddove il Cliente
            carichi all'interno dell'App i propri dati personali e il
            Commercialista ne fruisca al fine di porre in essere adempimenti
            fiscali per conto del Cliente, IBC S.r.l. assume il ruolo di
            Responsabile del trattamento ai sensi dell'art. 28 Reg. UE 679/2016,
            impegnandosi a prestare garanzie sufficienti per mettere in atto
            misure tecniche e organizzative adeguate in modo tale che il
            trattamento soddisfi i requisiti del Reg. UE 679/2016 e garantisca
            la tutela dei diritti dell'interessato.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Accettando le presenti condizioni generali, il Titolare del
            trattamento fornisce a IBC S.r.l., Responsabile del trattamento,
            un'autorizzazione generale alla nomina di sub-responsabili del
            trattamento che prestino, a loro volta, garanzie sufficienti per
            mettere in atto misure tecniche e organizzative adeguate in modo
            tale che il trattamento soddisfi i requisiti del Reg. UE 679/2016 e
            garantisca la tutela dei diritti dell'interessato.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Accettando le presenti condizioni generali, il Titolare del
            trattamento acconsente che IBC S.r.l., in qualità di Responsabile
            del trattamento, tratti i dati personali dell'Interessato nella
            maniera seguente:
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            FINALITÀ DEL TRATTAMENTO
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            I dati sono raccolti e trattati esclusivamente per le seguenti
            finalità:
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Erogazione del servizio come da contratto sottoscritto tra titolare
            del trattamento e l'interessato ed esecuzione di eventuali misure
            precontrattuali.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            TIPOLOGIA DEL DATI PERSONALI TRATTATI
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            I dati raccolti e trattati sono della tipologia "dati personali
            semplici" (art. 4 GDPR), quali ad esempio: recapiti di posta
            elettronica, numero di telefono, dati identificativi e anagrafici,
            dati relativi al settore di attività ricoperto, al nome, al tipo di
            attività effettuata e alle finalità perseguite.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            BASE GIURIDICA DEL TRATTAMENTO (art. 6 GDPR)
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            La base giuridica del trattamento dei dati è costituita dal
            contratto sottoscritto tra titolare del trattamento e l'interessato.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            DESTINATARI DEL TRATTAMENTO
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            I dati personali raccolti e trattati saranno comunicati a soggetti
            terzi rispetto al titolare del trattamento soltanto qualora
            strettamente necessario al perseguimento delle finalità convenute
            nel caso in cui lo impongano norme di legge.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Tali destinatari trattano i dati dei Clienti in qualità di titolari,
            responsabili o incaricati/autorizzati del trattamento a seconda
            delle circostanze.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Il titolare del trattamento si avvale, per lo svolgimento della
            propria opera e degli incarichi a lui assegnati, di collaboratori
            che agiscono in qualità di responsabili o incaricati del trattamento
            e presentano garanzie sufficienti per mettere in atto misure
            tecniche e organizzative adeguate al rispetto degli obblighi di cui
            al GDPR.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            CATEGORIE DI DESTINATARI
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Per destinatari si intendono, in via esemplificativa: avvocati,
            consulenti del lavoro, commercialisti, pubbliche amministrazioni e
            dipendenti.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            TRASFERIMENTO DEI DATI ALL'ESTERO
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Qualora si riveli necessario trasferire i dati al di fuori del
            territorio italiano, il titolare del trattamento si impegna a
            limitarne il trasferimento all'interno dell'Unione Europea.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Il trasferimento di dati a Paesi Terzi rispetto all'Unione europea
            avverrà soltanto qualora strettamente necessario e soltanto nei
            confronti di provider che offrono garanzie adeguate di tutela dei
            dati personali.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            DURATA DEL TRATTAMENTO
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            I dati raccolti saranno conservati fino al perseguimento delle
            finalità indicate comunque non oltre 10 anni dal raggiungimento
            delle medesime, per fini contabili e di difesa in giudizio, ai sensi
            degli artt. 2220 e 2946 c.c.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Accettando le presenti condizioni generali, il Titolare del
            trattamento e IBC S.r.l., in qualità di Responsabile del
            trattamento, pattuiscono che:
          </span>
        </p>
        <ol
          style={{
            margin: "0pt",
            paddingLeft: "0pt",
            listStyleType: "lower-latin",
          }}
        >
          <li
            style={{
              marginTop: "14pt",
              marginLeft: "31.33pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "4.67pt",
              fontFamily: "Montserrat",
              fontSize: "12pt",
            }}
          >
            IBC S.r.l. tratterà i dati personali soltanto su istruzione
            documentata del titolare del trattamento, anche in caso di
            trasferimento di dati personali verso un paese terzo o
            un'organizzazione internazionale, salvo che lo richieda il diritto
            dell'Unione o nazionale cui è soggetto il responsabile del
            trattamento; in tal caso, il IBC S.r.l. informerà il titolare del
            trattamento circa tale obbligo giuridico prima del trattamento, a
            meno che il diritto vieti tale informazione per rilevanti motivi di
            interesse pubblico;
          </li>
          <li
            style={{
              marginLeft: "32pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "4pt",
              fontFamily: "Montserrat",
              fontSize: "12pt",
            }}
          >
            IBC S.r.l. garantisce che le persone autorizzate al trattamento dei
            dati personali si siano impegnate alla riservatezza o abbiano un
            adeguato obbligo legale di riservatezza;
          </li>
          <li
            style={{
              marginLeft: "31.33pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "4.67pt",
              fontFamily: "Montserrat",
              fontSize: "12pt",
            }}
          >
            IBC S.r.l. si impegna ad adottare tutte le misure richieste ai sensi
            dell'articolo 32 del Reg. UE 679/2016;
          </li>
          <li
            style={{
              marginLeft: "32pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "4pt",
              fontFamily: "Montserrat",
              fontSize: "12pt",
            }}
          >
            IBC S.r.l. si impegna a rispettare le condizioni di cui ai paragrafi
            2 e 4 dell'articolo 28 del Reg. UE 679/2016 per ricorrere a un altro
            responsabile del trattamento;
          </li>
          <li
            style={{
              marginLeft: "31.33pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "4.67pt",
              fontFamily: "Montserrat",
              fontSize: "12pt",
            }}
          >
            IBC S.r.l., tenendo conto della natura del trattamento, si impegna
            ad assistere il titolare del trattamento con misure tecniche e
            organizzative adeguate, nella misura in cui ciò sia possibile, al
            fine di soddisfare l'obbligo del titolare del trattamento di dare
            seguito alle richieste per l'esercizio dei diritti dell'interessato
            di cui al capo III del Reg. UE 679/2016;
          </li>
          <li
            style={{
              marginLeft: "30pt",
              marginBottom: "0pt",
              lineHeight: "normal",
              paddingLeft: "6pt",
              fontFamily: "Montserrat",
              fontSize: "12pt",
            }}
          >
            IBC S.r.l. si impegna ad assistere il titolare del trattamento nel
            garantire il rispetto degli obblighi di cui agli articoli da 32 a 36
            del Reg. UE 679/2016, tenendo conto della natura del trattamento e
            delle informazioni a disposizione del responsabile del trattamento;
          </li>
          <li
            style={{
              marginLeft: "32pt",
              marginBottom: "14pt",
              lineHeight: "normal",
              paddingLeft: "4pt",
              fontFamily: "Montserrat",
              fontSize: "12pt",
            }}
          >
            IBC S.r.l. si impegna a mettere a disposizione del titolare del
            trattamento tutte le informazioni necessarie per dimostrare il
            rispetto degli obblighi di cui al presente articolo, consentendo e
            contribuendo alle attività di revisione, comprese le ispezioni,
            realizzate dal titolare del trattamento o da un altro soggetto da
            questi incaricato.
          </li>
        </ol>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Con riguardo alla lettera g) del primo comma, IBC S.r.l. si impegna
            ad informare immediatamente il titolare del trattamento qualora, a
            suo parere, un'istruzione violi il presente regolamento o altre
            disposizioni, nazionali o dell'Unione, relative alla protezione dei
            dati.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "13.5pt",
          }}
        >
          <strong>
            <span style={{ fontFamily: "Montserrat" }}>Notifiche</span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            L'Utente concorda nel ricevere comunicazioni da parte di IBC S.r.l.,
            ovvero notifiche relative al servizio e all'App, incluso eventuali
            alterazioni ai presenti Termini di Utilizzo e alla Informativa sulla
            Privacy, all'indirizzo di posta elettronica inserito durante la
            procedura di registrazione dell'account.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>Modifiche</span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Nel caso si rendesse necessario aggiornare l'App, i Servizi o i
            presenti Termini di Utilizzo, saranno adottate le misure Appropriate
            per informarLa, coerentemente con l'importanza dei cambiamenti
            effettuati. L'accesso o l'uso continuato dell'App o dei Servizi dopo
            l'entrata in vigore degli aggiornamenti implicano l'accettazione
            della versione più aggiornata del contenuto dei Termini di Utilizzo.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>Invalidità parziale</span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Se qualsiasi disposizione dei Termini e Condizioni sarà considerata
            invalida o irrealizzabile, per qualsiasi ragione o in qualsiasi
            misura, questa invalidità o in eseguibilità non avrà alcun effetto
            su, né renderà invalide o irrealizzabili, le restanti disposizioni
            dei presenti Termini e Condizioni e l'Applicazione di tale
            disposizione sarà effettuata nella massima misura consentita dalla
            legge.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Legge applicabile e giurisdizione
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Nel caso di problematiche, gli Utenti sono invitati a contattare
            preventivamente l'assistenza ai seguenti recapiti
          </span>
          <span style={{ fontFamily: "Montserrat" }}>&nbsp;</span>
          <em>
            <span style={{ fontFamily: "Montserrat" }}>assistenza@ibc.srl</span>
          </em>
          <span style={{ fontFamily: "Montserrat" }}>&nbsp;</span>
          <span style={{ fontFamily: "Montserrat" }}>.</span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            I presenti Termini e Condizioni e qualsiasi rapporto tra le Parti da
            essi derivante sono regolati dalla legge italiana.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Le Parti si impegneranno con ogni mezzo a pervenire ad una
            composizione amichevole delle eventuali controversie insorte tra
            loro derivanti dall'Applicazione dei presenti Termini e Condizioni.
            Qualora non sia possibile addivenire ad una soluzione amichevole,
            per qualsiasi controversia che dovesse insorgere tra le Parti, viene
            eletto in via esclusiva il Foro di Milano.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "13.5pt",
          }}
        >
          <strong>
            <span style={{ fontFamily: "Montserrat" }}>
              -------- SOLO PER UTENTI CONSUMATORI ai sensi del D.LGS 206/2005
              --------
            </span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Ferma restando l'applicazione delle norme inderogabili di
            derivazione Europea a tutela del consumatore, i presenti termini e
            condizioni sono regolati dalla legge italiana ed in particolare dal
            Codice del Consumo e dal Decreto legislativo 9 aprile 2003, n. 70
            ("Attuazione della Direttiva 2000/31/CE relativa a taluni aspetti
            giuridici dei servizi della società dell'informazione nel mercato
            interno, con particolare riferimento al commercio elettronico").
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Nel caso di controversie tra IBC S.r.l. e ciascun utente finale,
            nascenti dai presenti termini e condizioni, si informa che la
            Commissione Europea fornisce una piattaforma per la risoluzione
            alternativa extra-giudiziale delle controversie, accessibile sul
            sito
            <a
              href="http://ec.europa.eu/odr"
              style={{ textDecoration: "none" }}
            >
              <span className="Hyperlink" style={{ fontFamily: "Montserrat" }}>
                &nbsp;http://ec.europa.eu/odr
              </span>
            </a>
            .
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Per tutte le controversie relative ai presenti termini e condizioni
            sarà competente il Tribunale del luogo di domicilio o di residenza
            del consumatore in base alla legge applicabile oppure, a scelta del
            consumatore medesimo, il Tribunale di Milano.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Per tutte le controversie relative a contratti conclusi con i
            fornitori di servizi terzi, l'Utente è invitato a rivolgersi
            direttamente al partner e si ricorda che, in ogni caso, sarà
            competente il Tribunale del luogo di domicilio o di residenza del
            consumatore in base alla legge applicabile.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <strong>
            <span style={{ fontFamily: "Montserrat" }}>
              Ai sensi dell'art. 1342 cod. civ., l'Utente dichiara di conoscere
              ed accettare espressamente il contenuto delle seguenti clausole:
            </span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <em>
            <span style={{ fontFamily: "Montserrat" }}>
              Licenza d'uso; Legge applicabile e giurisdizione; Limitazione di
              responsabilità; Esclusione di garanzie; Responsabilità di IBC
              S.r.l.; Proprietà intellettuale; Durata e rinnovo; Attivazione
              dell'abbonamento, pagamenti e tariffe; Termine e risoluzione.
            </span>
          </em>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            lineHeight: "normal",
            fontSize: "12pt",
          }}
        >
          <span style={{ fontFamily: "Montserrat" }}>
            Ultimo aggiornamento: ottobre 2024
          </span>
        </p>
      </div>
    </div>
  );
};

export default TerminiCondizioniPage;
